export function formatCurrency(n) {
  return new Intl.NumberFormat("Vi", {
    style: "currency",
    currency: "VND"
  }).format(n);
}

export function capitalize(s) {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function formatNumberVN(n) {
  return new Intl.NumberFormat("Vi", {
    style: "decimal"
  }).format(n);
}

export function shortDescription(str, limitLength) {
  let length = limitLength;
  let strArr = str.split(" ");
  if (strArr.length <= length) {
    return str;
  }
  let result = "";
  for (let i = 0; i < length; i++) {
    result += strArr[i] + " ";
  }
  result.slice(0, -1);
  return result + "...";
}

export function randomString(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
